import React, { Fragment, useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import Calender from "Components/Calendar";
import dayjs from 'dayjs';
import { useAbsentsContext } from "Pages/Melder/Indienen/AbsentsContext";
import MentionInput from '../../../../../../Components/MentionInput/index.js';
// change language (for months names)
require('dayjs/locale/nl');
dayjs.locale('nl');


const weekDaysListWOWeekend = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag']

const Calendar = ({ formikProps, formDataState, setFormDataState }) => {
    const charactersPerInput = 150;
    const [formState, setFormState] = useState({ dateRange: [] });
    const { setFieldValue, errors } = formikProps;
    const [schedulerNoteUI, setSchedulerNoteUI] = useState('');
    const [plannerNoteUI, setPlannerNoteUI] = useState("");
    const { absentsData, fetchAbsentsList } = useAbsentsContext();

    useEffect(() => { setFieldValue('dateRange', formState.dateRange) }, [formState]);
    useEffect(() => {
        if (formikProps.values.schoolId && formikProps.values.organisationId) {
            fetchAbsentsList(
                formikProps.values.schoolId,
                formikProps.values.organisationId
            );
        }
    }, [
        formikProps.values.schoolId,
        formikProps.values.organisationId
    ]);

    const manageDays = (daysElemArray) => {

    }

    const manageDate = (day) => {

    }

    const removeDate = (day) => {

    }

    const handleSchedulerNoteChange = (value, mentions) => {
        setSchedulerNoteUI(value);

        setFormDataState(prev => ({
            ...prev,
            schedulerNote: value,
            mentions
        }));
    };
    const handlePlannerNoteChange = (value, mentions) => {
        setPlannerNoteUI(value);

        setFormDataState(prev => ({
            ...prev,
            substitutionNote: value,
            mentions
        }));
    };

    const gym = [];

    formDataState.dateRange.map(day => {

        let dayId = [];
        let sift = [];
        let weekDayNum = dayjs(day.date).day();
        if (day.dayPart === "ochtend") {
            dayId = [weekDayNum * 2 - 1]
            sift = [' ochtend'];
        } else if (day.dayPart === "middag") {
            dayId = [weekDayNum * 2]
            sift = [' middag']
        } else {
            dayId = [weekDayNum * 2 - 1, weekDayNum * 2]
            sift = [' ochtend', ' middag']
        }
        let gymObj = sift.map((dayPart, dayPartId) => {
            return {
                id: dayId[dayPartId],
                day: weekDaysListWOWeekend[weekDayNum - 1] + dayPart,
            }
        });

        !gym.some(obj => obj.day == gymObj[0].day) && gym.push(...gymObj);
        gym.sort((x, y) => x.id - y.id);

    })


    return (
        <Fragment>
            <Calender data={formDataState} prevState={formState} setState={setFormState} weekDays={weekDaysListWOWeekend} manageDays={manageDays} manageDate={manageDate} removeDate={removeDate} setDatesState={setFormDataState} isDisabled={errors.dateRange} />
            <Row className="calendar-fields-container">
                <Col className="mt-5">
                    <Label>Gym</Label>
                    <Typeahead
                        id="gym"
                        name="gym"
                        labelKey="day"
                        options={gym}
                        multiple={true}
                        placeholder="Selecteer gym dagen"
                        className="d-flex" style={{ flex: "1 0 185px" }}
                        defaultSelected={formDataState.gym}
                        onChange={gym => {
                            setFieldValue('gym', gym.sort((x, y) => x.id - y.id).map(e => e.id))
                            setFormDataState({ ...formDataState, gym })
                        }}
                    />
                </Col>
                <Col className="mt-5">
                    <Label>Opmerking aan vervanger</Label>
                    <div className="border border-1 p-1 rounded">
                        <MentionInput
                            className="mentions planner-mentions"
                            value={plannerNoteUI}
                            onChange={handlePlannerNoteChange}
                            absentsData={absentsData}
                            placeholder={"Voer hier uw opmerking in\nTyp @ om een gebruiker te vermelden"}
                        />
                    </div>
                </Col>

                <Col className="mt-5">
                    <Label>Opmerking aan planner</Label>

                    <div className="border border-1 p-1 rounded">
                        <MentionInput
                            className="mentions planner-mentions"
                            value={schedulerNoteUI}
                            onChange={handleSchedulerNoteChange}
                            absentsData={absentsData}
                            placeholder={"Voer hier uw opmerking in\nTyp @ om een gebruiker te vermelden"}
                        />
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}

export default Calendar;
